import { RootState } from '@/redux/store'

export const selectStoreItemAvailability = (state: RootState) => state['@storeItemAvailability'].data;
